import { Box, Typography } from '@mui/material'
import { useIntl } from 'react-intl'
import { messages } from '../messages'
import { UnassignedConsignment } from '../types'
import JourneyViewRouteCard from './JourneyViewRouteCard'

type JourneyViewLegSectionProps = {
  leg: any
  legNumber: number
  transportModeName: string
  consignments: UnassignedConsignment[]
}

const JourneyViewLegSection = ({
  leg,
  legNumber,
  transportModeName,
  consignments,
}: JourneyViewLegSectionProps) => {
  const { formatMessage } = useIntl()

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          bgcolor: 'grey.100',
          p: 1.5,
          borderRadius: 1,
        }}
      >
        {formatMessage(messages.legNumber, { number: legNumber })} - {transportModeName}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        {leg.routes && leg.routes.length > 0 ? (
          leg.routes.map((route: any, index: number) => (
            <JourneyViewRouteCard
              key={route.id}
              route={route}
              routeNumber={index + 1}
              consignments={consignments}
            />
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            {formatMessage(messages.noRoutes)}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default JourneyViewLegSection
